import type { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './Card.module.scss';

/** A rule between groups of content inside a card. */
export function CardDivider(props: { className?: string }) {
    const { className } = props;
    return <hr className={classNames(styles.divider, className)} />;
}

interface CardTextProps {
    children: ReactNode;
    /** `body` reads as running text; `footnote` is the smaller secondary line under it. */
    variant?: 'body' | 'footnote';
    className?: string;
}

/** A paragraph of card copy in the card's text style. */
export function CardText(props: CardTextProps) {
    const { children, variant = 'body', className } = props;
    return (
        <p className={classNames(styles.text, className)} data-variant={variant}>
            {children}
        </p>
    );
}

interface CardImageProps {
    src?: string;
    alt: string;
    className?: string;
}

/** A photo letterboxed on a dark backdrop, capped at 500px so it does not dominate the card. */
export function CardImage(props: CardImageProps) {
    const { src, alt, className } = props;
    return (
        <div className={classNames(styles.image, className)}>
            <img src={src} alt={alt} />
        </div>
    );
}
